import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoWrapperFn = /* @__PURE__ */ createRecipe('logo-wrapper', {}, [])

const logoWrapperVariantMap = {
  "color": [
    "danger"
  ]
}

const logoWrapperVariantKeys = Object.keys(logoWrapperVariantMap)

export const logoWrapper = /* @__PURE__ */ Object.assign(memo(logoWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoWrapper',
  __getCompoundVariantCss__: logoWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoWrapperVariantKeys,
  variantMap: logoWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoWrapperVariantKeys)
  },
  getVariantProps: logoWrapperFn.getVariantProps,
})